import {inject} from '@angular/core'
import {filter, Observable} from 'rxjs'

import {LOCAL_STORAGE} from '../application/providers'

export class LocalStorageService<T> {

  private readonly ils: Storage = inject(LOCAL_STORAGE)

  /**
   *
   * @param keyName - Just a name, try to keep it unique.
   * @param data$ - The point of this is to keep this in sync with local storage.
   */
  constructor(
    private readonly keyName: string,
    private readonly data$: Observable<T>
  ) {
    this.data$
      .pipe(filter(Boolean))
      .subscribe({
        next: (val: T) => this.set(val)
      })
  }

  get(): T | null {
    try {
      return JSON.parse(this.ils.getItem(this.keyName) as string) as T
    } catch {
      return null
    }
  }

  set(val: T): void {
    this.ils.setItem(this.keyName, JSON.stringify(val))
  }

  clear(): void {
    this.ils.clear()
  }
}
